export default {"src":"/_next/static/media/pin-green-mobile.de693188.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};